export function variationName(name, value) {
  return `${name}${value.charAt(0).toUpperCase()}${value.slice(1)}`
}
